"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IComponentFunctionSignalAttributesSchema = void 0;
const Signal_1 = require("../DesignModels/Signal");
exports.IComponentFunctionSignalAttributesSchema = Signal_1.SignalSchema.pick({
    signalDirection: true,
    attributes: true,
    diffPair: true,
    supportedDriveModes: true,
    floatingBehavior: true,
    ties: true,
});
//# sourceMappingURL=IComponentFunctionSignalAttributes.js.map